export default __webpack_public_path__ + "static/media/Snd_TryU.870b684e.mp3";